import React from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import styles from './DownloadReports.module.css';
import { useNavigate } from 'react-router';
import CopyRight from '../../components/CopyRight/CopyRight';

function DownloadReports() {
  const reports = new Array(6).fill({
    title: 'Students Report',
    date: '14/06/2025, 1:35 PM',
    user: 'Darshan',
  });

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.DownloadReports}>
        <div className={styles.header} onClick={() => navigate(-1)}>
          <FaChevronLeft className={styles.backIcon} />
          <span>Reports</span>
        </div>

        <div className={styles.body}>
          <div className={styles.sectionTitle}>Reports generated</div>

          <div className={styles.grid}>
            {reports.map((report, index) => (
              <div key={index} className={styles.reportCard}>
                <div>
                  <div className={styles.title}>{report.title}</div>
                  <div className={styles.meta}>
                    On {report.date}.By {report.user}
                  </div>
                </div>
                <div className={styles.download}>Download</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
}

export default DownloadReports;
